<template>
    <div style="margin-top: 25px" class="row section border">
        <div class="col s12">
            <div id="recover-password-form" class="col s10 offset-s1" novalidate>
                <div class="row">
                    <eg-alert :show="show" :message="message" :color="colorAlert" @show="show = $event" />
                    <div class="input-field">
                        <eg-input
                            disabled
                            v-model.trim="email"
                            title="E-mail"
                            :value="email"
                            :rules="rules.email"
                            :valid="valid"
                            @valid="rules.email.valid = $event"
                        />
                        <eg-input
                            v-model.trim="password"
                            title="Senha"
                            inputType="password"
                            :value="password"
                            :rules="rules.password"
                            :valid="valid"
                            @valid="rules.password.valid = $event"
                        />
                        <eg-input
                            v-model.trim="confirmPassword"
                            title="Confirmar Senha"
                            inputType="password"
                            :value="confirmPassword"
                            :rules="rules.confirmPassword"
                            :valid="valid"
                            @valid="rules.confirmPassword.valid = $event"
                        />
                    </div>
                </div>
                <eg-button
                    class="btn light-blue darken-4 right col xl3 l3 m3 s12"
                    @click="validateInput"
                    :loading="loading"
                    :disabled="!formValid || send"
                >
                    Recuperar senha
                </eg-button>
            </div>
        </div>
    </div>
</template>

<script>
import { changePassword, validTokenRecoverPassword } from '@/services';
import { mapActions } from 'vuex';
export default {
    data: () => ({
        email: '',
        password: '',
        confirmPassword: '',
        loading: false,
        show: false,
        valid: false,
        message: '',
        colorAlert: 'red',
        send: false,
        rules: {
            email: {
                required: true,
                type: 'email',
                name: 'E-mail',
                valid: true
            },
            password: {
                required: true,
                type: 'text',
                name: 'Senha',
                valid: true
            },
            confirmPassword: {
                required: true,
                type: 'text',
                name: 'Confirmar Senha',
                valid: true
            }
        }
    }),
    async created() {
        try {
            const { token } = this.$route.query;
            const { userEmail, error } = await validTokenRecoverPassword(token);
            if (error) {
                console.log(error);
                this.showNotification({ text: 'Um erro aconteceu', type: 'error' });
            }else {
                this.email = userEmail;
            }
        } catch (e) {
            console.error(e);
            this.showNotification({ text: 'Um erro aconteceu', type: 'error' });
        }
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        async validateInput() {
            this.loading = true;
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            if (this.formValid) {
                if (this.password != this.confirmPassword) {
                    this.loading = false;
                    return this.alert('Por favor, forneça o mesmo valor de senha', 'red');
                }
                return await this.changePassword();
            }
            this.loading = false;
        },
        async changePassword() {
            try {
                const formData = await this.makePostData();
                const { error } = await changePassword(formData);
                if (error) {
                    const { message } = JSON.parse(error.request.response);
                    this.showNotification({ text: message, type: 'error' });
                } else {
                    this.showNotification({ text: 'Senha alterada com sucesso', type: 'success' });
                    this.$router.push({ name: 'Login' });
                }
            } catch (e) {
                console.error(e);
                this.showNotification({ text: 'Um erro aconteceu', type: 'error' });
            } finally {
                this.loading = false;
            }
        },
        makePostData() {
            const { token } = this.$route.query;
            return {
                email: this.email,
                new_password: this.password,
                new_password_confirmation: this.confirmPassword,
                token
            };
        },
        alert(message, color) {
            this.message = message;
            this.colorAlert = color;
            this.show = true;
        }
    },
    computed: {
        formValid() {
            const { email, password, confirmPassword } = this.rules;
            return email.valid && password.valid && confirmPassword.valid;
        }
    }
};
</script>

<style></style>
